// https://app.growthbook.io/features/mccerts-3290_v1
export const COHORT_URGENCY_FLAG = 'mccerts-3290_v1'
